import axios from "@axios";

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getSelectedItems(state) {
      return state.items.map((tenant) => ({
        value: tenant.id,
        label: tenant.name,
      }));
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
  },
  actions: {
    async getAll({ commit }, params) {
      try {
        const response = await axios.get(`${window.__env.VUE_APP_FILESYSTEM_URL}/v1/tenant`, {params})
        if (response.status != 200) {
          return [];
        }

        if (response.data.data == null){
          response.data.data = []
        }

        commit("setData", response.data.data);
        return response.data;

      } catch (error) {
        console.error(error);
      }

    },
    async add(_, params) {
      const { data } = await axios.post(`${window.__env.VUE_APP_FILESYSTEM_URL}/v1/tenant`, params);

      return data;
    },
    async edit(_, { id, params }) {
      const { data } = await axios.post(`${window.__env.VUE_APP_FILESYSTEM_URL}/v1/tenant/update/${id}`, params);

      return data;
    },
    async delete(_, id) {
      const response = await axios.post(`${window.__env.VUE_APP_FILESYSTEM_URL}/v1/tenant/delete/${id}`);

      return response;

    },
    clear({ commit }) {
      commit("setData", []);
    },
  },
};
